import React, {memo} from "react";
import classNames from "classnames/bind";
import {ASSET_TYPE, convertDuration} from "utils";
import DefaultThumbnail from "images/objectPanel/ic_default_thumbnail.svg";
import OverlayPlayButton from "../OverlayPlayButton";
import ProgressBar from "../ProgressBar";
import usePlayAssetPreview from "../hooks/usePlayAssetPreview";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

/**
 * @type appearance: { listType, small }
 * @param {*} uploadProgress, assetType:string, thumbnail, duration, appearance
 */

function AssetItemThumbnail({uploadProgress, asset, thumbnail, duration, appearance}) {
  const {handlePlay, stopPlay, isPlaying} = usePlayAssetPreview();
  const isVideo = asset.topCategory === ASSET_TYPE.VIDEO;
  const isVideoPlaying = isVideo && isPlaying;

  return (
    <OverlayPlayButton handlePlay={handlePlay} stopPlay={stopPlay} isPlaying={isPlaying} appearance={{hasNoPlayButton: !isVideo}}>
      <div className={cn("container", appearance?.listType, appearance?.small && "small")}>
        {isVideoPlaying ? (
          <div className={styles.asset}>
            <video className={styles.video} autoPlay muted>
              <source src={asset.url} type="video/mp4" />
            </video>
          </div>
        ) : (
          <img className={styles.asset} src={thumbnail || DefaultThumbnail} alt="asset_img" />
        )}
        {duration && <span className={styles.duration_tag}>{<p>{convertDuration(duration)}</p>}</span>}
      </div>
      <ProgressBar uploadProgress={uploadProgress} />
    </OverlayPlayButton>
  );
}

export default memo(AssetItemThumbnail);
